import React from "react";
import "./Departments.css";

const JilhaPaniSwachhataMission = () => {
  return (
    <div className="dept-page">

      {/* TOP STRIP */}
      <div className="dept-top-strip">
        <span>🏛 महाराष्ट्र शासन</span>
        <span>जिल्हा पाणी व स्वच्छता मिशन</span>
      </div>

      {/* HEADER */}
      <header className="dept-header">

        <div className="dept-header-emblem">
          🚰
        </div>

        <div className="dept-header-text">

          <div className="dept-header-org">
            जिल्हा परिषद विभाग
          </div>

          <h1 className="dept-header-title">
            जिल्हा पाणी व स्वच्छता मिशन
          </h1>

          <div className="dept-header-subtitle">
            स्वच्छ भारत मिशन (ग्रामीण) व जल जीवन मिशन
          </div>

        </div>

        <div className="dept-header-badge">
          WATER & SANITATION
        </div>

      </header>

      {/* NAVIGATION */}
      <div className="dept-nav">

        <button className="dept-nav-tab active">
          विभाग माहिती
        </button>

        <button className="dept-nav-tab">
          स्वच्छ भारत मिशन
        </button>

        <button className="dept-nav-tab">
          जल जीवन मिशन
        </button>

        <button className="dept-nav-tab">
          संपर्क
        </button>

      </div>

      {/* MAIN */}
      <main className="dept-main">

        {/* HERO */}
        <section className="dept-intro">

          <div className="dept-intro-label">
            स्वच्छ व निरोगी ग्रामीण जीवन
          </div>

          <p className="dept-intro-text">
            <strong>जिल्हा पाणी व स्वच्छता मिशन</strong>
            हा विभाग ग्रामीण भागात सुरक्षित पाणीपुरवठा,
            स्वच्छता सुविधा, वैयक्तिक शौचालय, सांडपाणी
            व्यवस्थापन आणि जनजागृती उपक्रम राबविण्यासाठी
            कार्यरत आहे. स्वच्छ भारत मिशन (ग्रामीण)
            आणि जल जीवन मिशन या केंद्र शासनाच्या
            महत्त्वपूर्ण योजनांची प्रभावी अंमलबजावणी
            गावपातळीवर करण्यात येते.
          </p>

        </section>

        {/* STATS */}
        <section className="dept-stats">

          <div className="dept-stat-card">
            <div className="dept-stat-value">55L</div>
            <div className="dept-stat-label">
              प्रति व्यक्ती पाणीपुरवठा
            </div>
          </div>

          <div className="dept-stat-card">
            <div className="dept-stat-value">₹12K</div>
            <div className="dept-stat-label">
              वैयक्तिक शौचालय अनुदान
            </div>
          </div>

          <div className="dept-stat-card">
            <div className="dept-stat-value">100%</div>
            <div className="dept-stat-label">
              स्वच्छ गाव अभियान
            </div>
          </div>

          <div className="dept-stat-card">
            <div className="dept-stat-value">JJM</div>
            <div className="dept-stat-label">
              जल जीवन मिशन
            </div>
          </div>

        </section>

        {/* LEFT CONTENT */}
        <div>

          {/* ABOUT */}
          <section className="dept-section">

            <div className="dept-section-header">

              <div className="dept-section-icon">
                💧
              </div>

              <h2 className="dept-section-title">
                विभागाची माहिती
              </h2>

            </div>

            <div className="scheme-list">

              <div className="scheme-card">

                <div className="scheme-card-name">
                  पाणी व स्वच्छता विभाग
                </div>

                <div className="scheme-card-desc">
                  पुणे जिल्हा परिषदेमध्ये पाणी व स्वच्छता
                  विकासाशी संबंधित विविध योजना व कार्यक्रम
                  राबविण्यासाठी हा विभाग कार्यरत आहे.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  मुख्य उद्दिष्ट
                </div>

                <div className="scheme-card-desc">
                  ग्रामीण भागातील प्रत्येक व्यक्तीस
                  दररोज ५५ लिटर शुद्ध पाणी उपलब्ध
                  करून देणे व स्वच्छ वातावरण निर्माण करणे.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  स्वच्छता उपक्रम
                </div>

                <div className="scheme-card-desc">
                  गावपातळीवर वैयक्तिक शौचालय,
                  घनकचरा व्यवस्थापन आणि सांडपाणी
                  व्यवस्थापन प्रकल्प राबविणे.
                </div>

              </div>

            </div>

          </section>

          {/* SWACHH BHARAT */}
          <section
            className="dept-section"
            style={{ marginTop: "24px" }}
          >

            <div className="dept-section-header">

              <div className="dept-section-icon">
                🚽
              </div>

              <h2 className="dept-section-title">
                स्वच्छ भारत मिशन (ग्रामीण)
              </h2>

            </div>

            <div className="scheme-list">

              <div className="scheme-card">

                <div className="scheme-card-name">
                  आरोग्यदायी जीवनशैली
                </div>

                <div className="scheme-card-desc">
                  महिला, अबाल-वृद्ध यांच्यासाठी
                  सुलभ शौचालय सुविधा उपलब्ध
                  करून स्वच्छतेच्या सवयी विकसित करणे.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  पर्यावरण संरक्षण
                </div>

                <div className="scheme-card-desc">
                  माती, हवा आणि पाणी प्रदूषणमुक्त
                  करून गाव स्वच्छ व निरोगी बनविणे.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  वैयक्तिक शौचालय अनुदान
                </div>

                <div className="scheme-card-desc">
                  पात्र लाभार्थ्यांना ₹12,000
                  पर्यंत प्रोत्साहन अनुदान उपलब्ध.
                </div>

                <div className="scheme-card-amount">
                  ₹12,000 अनुदान
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  सार्वजनिक स्वच्छता सुविधा
                </div>

                <div className="scheme-card-desc">
                  सार्वजनिक शौचालय बांधकाम,
                  सांडपाणी व घनकचरा व्यवस्थापन
                  प्रकल्प गावपातळीवर राबविले जातात.
                </div>

              </div>

            </div>

          </section>

          {/* JJM */}
          <section
            className="dept-section"
            style={{ marginTop: "24px" }}
          >

            <div className="dept-section-header">

              <div className="dept-section-icon">
                🚰
              </div>

              <h2 className="dept-section-title">
                जल जीवन मिशन
              </h2>

            </div>

            <div className="scheme-list">

              <div className="scheme-card">

                <div className="scheme-card-name">
                  वैयक्तिक नळजोडणी
                </div>

                <div className="scheme-card-desc">
                  वैयक्तिक नळजोडणी नसलेल्या
                  ग्रामीण कुटुंबांना नळजोडणी
                  उपलब्ध करून देणे.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  सुरक्षित पाणीपुरवठा
                </div>

                <div className="scheme-card-desc">
                  प्रत्येक घराला सुरक्षित,
                  नियमित आणि शुद्ध पिण्याचे
                  पाणी उपलब्ध करून देणे.
                </div>

              </div>

              <div className="scheme-card">

                <div className="scheme-card-name">
                  ग्रामस्तर अंमलबजावणी
                </div>

                <div className="scheme-card-desc">
                  गावपातळीवर स्थानिक समितींच्या
                  सहभागातून योजना प्रभावीपणे
                  राबविणे.
                </div>

              </div>

            </div>

          </section>

          {/* AWARENESS */}
          <section
            className="dept-section"
            style={{ marginTop: "24px" }}
          >

            <div className="dept-section-header">

              <div className="dept-section-icon">
                📢
              </div>

              <h2 className="dept-section-title">
                जनजागृती व प्रशिक्षण
              </h2>

            </div>

            <div className="dept-services-grid">

              <div className="dept-service-item">
                स्वच्छता जनजागृती
              </div>

              <div className="dept-service-item">
                ग्रामस्तर प्रशिक्षण
              </div>

              <div className="dept-service-item">
                पाणी संवर्धन
              </div>

              <div className="dept-service-item">
                सांडपाणी व्यवस्थापन
              </div>

              <div className="dept-service-item">
                घनकचरा व्यवस्थापन
              </div>

              <div className="dept-service-item">
                आरोग्यदायी जीवनशैली
              </div>

            </div>

          </section>

        </div>

        {/* SIDEBAR */}
        <aside className="dept-sidebar">

          {/* INFO */}
          <div className="dept-info-card">

            <div className="dept-info-card-title">
              विभाग माहिती
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                प्रमुख योजना
              </div>

              <div className="dept-info-val">
                SBM & JJM
              </div>
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                पाणीपुरवठा
              </div>

              <div className="dept-info-val">
                55 लिटर प्रतिदिन
              </div>
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                शौचालय अनुदान
              </div>

              <div className="dept-info-val">
                ₹12,000
              </div>
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                कार्यक्षेत्र
              </div>

              <div className="dept-info-val">
                ग्रामीण भाग
              </div>
            </div>

          </div>

          {/* CONTACT */}
          <div className="dept-contact-card">

            <div className="dept-contact-card-title">
              संपर्क माहिती
            </div>

            <div className="dept-contact-row">
              <span>📞</span>
              <span>020-26052938</span>
            </div>

            <div className="dept-contact-row">
              <span>📍</span>
              <span>जिल्हास्तरीय कार्यालये</span>
            </div>

            <div className="dept-contact-row">
              <span>🚰</span>
              <span>पाणी व स्वच्छता विभाग</span>
            </div>

          </div>

          {/* QUICK SERVICES */}
          <div className="dept-info-card">

            <div className="dept-info-card-title">
              प्रमुख सेवा
            </div>

            <div className="dept-services-grid">

              <div className="dept-service-item">
                नळजोडणी
              </div>

              <div className="dept-service-item">
                शौचालय सुविधा
              </div>

              <div className="dept-service-item">
                स्वच्छता अभियान
              </div>

              <div className="dept-service-item">
                पाणी गुणवत्ता
              </div>

              <div className="dept-service-item">
                सांडपाणी व्यवस्थापन
              </div>

              <div className="dept-service-item">
                जनजागृती कार्यक्रम
              </div>

            </div>

          </div>

        </aside>

      </main>

      {/* FOOTER */}
      <footer className="dept-footer">
        <strong>जिल्हा पाणी व स्वच्छता मिशन</strong>
        {" "}• जिल्हा परिषद प्रशासन
      </footer>

    </div>
  );
};

export default JilhaPaniSwachhataMission;